import React from 'react'
import { DSSizes } from 'shared/timber/common/types'

import './EmptyState.scss'

import EmptyStateIcon from './components/Icon'
import EmptyStateTitle from './components/Title'
import EmptyStateFooter from './components/Footer'
import EmptyStateDescription from './components/Description'
import classy from 'shared/utils/classy'

export type EmptyStateSize = Extract<DSSizes, 'sm' | 'md' | 'lg'>

export interface EmptyStateProps {
  size?: EmptyStateSize
  children: React.ReactNode
  appearance?: 'condensed' | 'default'
  'data-testid'?: string
}

const EmptyState = ({
  size = 'md',
  appearance = 'default',
  children,
  'data-testid': dataTestId = 'empty-state',
}: EmptyStateProps) => {
  const renderChildren = () => {
    return React.Children.map(children, (child: React.ReactNode, index) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child as any, {
          key: index,
          size: size,
        })
      } else {
        return null
      }
    })
  }

  return (
    <div
      className={classy('EmptyState', `EmptyState--${appearance}`)}
      data-appearance={appearance}
      data-testid={dataTestId}
    >
      <div className="EmptyState__Content">{renderChildren()}</div>
    </div>
  )
}

EmptyState.displayName = 'EmptyState'

EmptyState.Icon = EmptyStateIcon
EmptyState.Icon.displayName = 'EmptyState.Icon'

EmptyState.Title = EmptyStateTitle
EmptyState.Title.displayName = 'EmptyState.Title'

EmptyState.Description = EmptyStateDescription
EmptyState.Description.displayName = 'EmptyState.Description'

EmptyState.Footer = EmptyStateFooter
EmptyState.Footer.displayName = 'EmptyState.Footer'

export default EmptyState
